<template>
  <CoreSelectionDrawer
    has-search
    has-footer
    is-checked-variant
    :title="t('Город врача', options)"
    :placeholder="t('Название города', options)"
    :is-back="isBack"
    :value="value"
    :items="cities"
    :selected-item="selectedCity"
    :loading="loading"
    :error="error"
    attach=".vue-the-doctors-filters .v-application"
    @input="$emit('input', false)"
    @back="$emit('input', false)"
    @click-item="handleClickCity"
  >
    <template #append-header>
      <v-btn
        v-if="selectedCity"
        color="primary"
        small
        text
        class="ml-auto"
        @click="$emit('city:reset')"
      >
        {{ t('Сбросить', options) }}
      </v-btn>
    </template>
    <template #footer>
      <slot
        name="footer"
        v-bind="{ selectedCity }"
      />
    </template>
  </CoreSelectionDrawer>
</template>

<script setup lang="ts">
import {
  computed,
  ref,
  toRefs,
  watch,
} from 'vue'
import I18NextVue from 'i18next'
import apiCities from 'www/vue_components/common/TheFilters/doctors/api/apiCities'
import CoreSelectionDrawer from 'src/core/CoreSelectionDrawer/CoreSelectionDrawer.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input', 'city:selected', 'city:reset'])

const props = defineProps<{
  value: boolean
  isBack?: boolean
  selectedCity: Filters['city']
}>()

const {
  value: isVisibleModal,
} = toRefs(props)

const loading = ref(false)
const error = ref(false)

const cities = ref<NonNullable<Filters['city']>[]>([])
const citiesCache: Map<string, NonNullable<Filters['city']>[]> = new Map()

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const loadCities = async () => {
  error.value = false
  loading.value = true

  try {
    const requestData = {}
    const cacheKey = JSON.stringify(requestData)

    if (!citiesCache.has(cacheKey)) {
      const { data } = await apiCities.get()

      citiesCache.set(cacheKey, data)
    }

    cities.value = citiesCache.get(cacheKey) || []
  } catch {
    error.value = true
  } finally {
    loading.value = false
  }
}

watch(isVisibleModal, async () => {
  if (isVisibleModal.value) {
    await loadCities()
  }
})

const handleClickCity = (city: NonNullable<Filters['city']>) => {
  emit('city:selected', city)
}
</script>
